<template>
    <div
        class="resize-container"
        :style="`height: ${contentHeight}px`"
    >
        <svg
            class="content-placeholder"
            :height="contentHeight"
            width="10"
        >
            <rect
                x="0"
                y="0"
                width="10"
                :height="contentHeight"
                style="fill:transparent"
            />
        </svg>
        <div
            ref="content"
            class="content-container"
        >
            <slot
                :width="width"
            />
        </div>
    </div>
</template>

<script>
/**
 * Component that detects when its width changes and provides it to its child slot as an attribute
 *
 * Useful for SVGs that need their width explicitly set, but also want to take advantage of things
 * like flexbox
 */
export default {
    data() {
        return {
            width: 0,
            contentHeight: 0
        };
    },
    mounted() {
        this.updateCb = () => this.updateDimensions();

        this.updateDimensions();
        window.addEventListener('resize', this.updateCb);
    },
    destroyed() {
        window.removeEventListener('resize', this.updateCb);
    },
    methods: {
        updateDimensions() {
            const { width } = this.$el.getBoundingClientRect();
            this.width = Math.max(width, 60);
            // Wait for the children to update, then get the content height
            // and force the container to be the right height
            this.$nextTick(() => {
                const { height } = this.$refs.content.getBoundingClientRect();
                // console.log('Height for', this.$el, height);
                this.contentHeight = height;
            });
        }
    }
};
</script>

<style lang="postcss" scoped>
div.resize-container {
    @apply relative;
}

/* Content is absolutely positioned so it doesn't affect document flow, only reacts to it */
div.content-container {
    @apply absolute top-0 left-0;
    /* display: none !important; */
}

.pdf .resize-container {
    min-width: 350px;
    max-width: 350px;
}
</style>
